// This file was automatically generated from appshared.docTags.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.docTags');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.feedItemId && opt_data.docTags.length > 0) ? '<img class="doc-tag-icon el8FeedItemDocTagIcon" src="/static/images/tag_small.png"/>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.tooltipCombined = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<a class="add-edit-tags-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  var docTagList9050 = opt_data.docTagMaps;
  var docTagListLen9050 = docTagList9050.length;
  for (var docTagIndex9050 = 0; docTagIndex9050 < docTagListLen9050; docTagIndex9050++) {
    var docTagData9050 = docTagList9050[docTagIndex9050];
    output.append('<div class="el8DocTagTooltipWrap"><div class="el8DocTagTooltipValue">', soy.$$escapeHtml(docTagData9050.value), '</div>', (docTagData9050.code) ? '<div class="el8DocTagTooltipCodeLine">' + soy.$$escapeHtml(docTagData9050.code) + ' (' + soy.$$escapeHtml(docTagData9050.codeType) + ')</div>' : '', (docTagData9050.description) ? '<div class="el8DocTagTooltipDescriptionNew">' + soy.$$escapeHtml(docTagData9050.description) + '</div>' : '', '</div>');
  }
  output.append('</a>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DocTagsLineWrap ', (opt_data.align && opt_data.align == 'right') ? 'el8AlignRight' : '', '">');
  var tagList9075 = opt_data.docTags;
  var tagListLen9075 = tagList9075.length;
  for (var tagIndex9075 = 0; tagIndex9075 < tagListLen9075; tagIndex9075++) {
    var tagData9075 = tagList9075[tagIndex9075];
    output.append('<div class="el8DocTagWrap">');
    el8.template.appshared.docTags.docTag({tag: tagData9075}, output);
    output.append('</div>');
  }
  output.append((opt_data.feedItemId && opt_data.docTags.length > 0) ? '<a class="add-edit-tags-trigger el8FontSmall" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">edit</a>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.docTagsSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<fieldset class="noBorderForm"><div class="doctags"></div></fieldset>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.docTagsLine = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSection"><label></label><div class="el8FieldShortLabelPadding">');
  if (opt_data.docTags) {
    var tagList9093 = opt_data.docTags;
    var tagListLen9093 = tagList9093.length;
    for (var tagIndex9093 = 0; tagIndex9093 < tagListLen9093; tagIndex9093++) {
      var tagData9093 = tagList9093[tagIndex9093];
      output.append('<div class="el8DocTagWrap">');
      el8.template.appshared.docTags.docTag({tag: tagData9093}, output);
      output.append('</div>');
    }
  }
  output.append((opt_data.docTags && opt_data.docTags.length > 0) ? '<a class="add-edit-tags-trigger el8FormLink">edit</a>' : '<a class="add-edit-tags-trigger el8FormLink">+ Tag</a>', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.docTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="', (opt_data.tag.code) ? 'el8DocTagCoded doctag-coded' : 'el8DocTag', ' ', (opt_data.removeButton) ? 'mr8' : '', '" data-id="', soy.$$escapeHtml(opt_data.tag.id), '">', (opt_data.tag.code) ? '' : '', soy.$$escapeHtml(opt_data.tag.value), (opt_data.tag.code) ? '&thinsp;&bull;' : '', '</span>', (opt_data.removeButton) ? '<a class="el8RemoveButton el8StandardFontSize remove-trigger"></a>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.docTags.tooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DocTagTooltipWrap"><div class="el8DocTagTooltipValue">', soy.$$escapeHtml(opt_data.docTag.value), '</div>', (opt_data.docTag.code) ? '<div class="el8DocTagTooltipCodeLine">' + soy.$$escapeHtml(opt_data.docTag.code) + ' (' + soy.$$escapeHtml(opt_data.docTag.codeType) + ')</div>' : '', (opt_data.docTag.description) ? '<div class="el8DocTagTooltipDescription">' + soy.$$escapeHtml(opt_data.docTag.description) + '</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
